
import { useState } from 'react';

export type TimeRange = 'year' | 'quarter' | 'month';

export const useTimeRange = (defaultRange: TimeRange = 'year') => {
  const [timeRange, setTimeRange] = useState<TimeRange>(defaultRange);

  const getFilteredData = <T>(data: T[], sliceAmount: number) => {
    if (timeRange === 'month') {
      return data.slice(-1);
    } else if (timeRange === 'quarter') {
      return data.slice(-3);
    }
    return data;
  };

  return {
    timeRange,
    setTimeRange,
    getFilteredData
  };
};
